import styled from "styled-components";
import {
  screenSizes
} from "./theme";

export const pageContentWidth = screenSizes.XXL;

export const PageContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: calc(100% - 2 * var(--pageMargin));
  max-width: ${pageContentWidth}px;
  margin: 0 auto;
  min-height: auto;
  transition: all 300ms ease-in-out;
  @media (max-width: ${screenSizes.M}px) {
    margin: 0px;
  }
`;

export const FlexCol = styled.div<any>`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "center"};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
  ${(props) => props.flex && `flex: ${props.flex};`}
  ${(props) => props.margin && `margin: ${props.margin};`}
`;
export const FlexRow = styled.div<any>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.gap ? props.gap : "")};
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "center"};
`;

export const ErrorText = styled.div`
  color: ${(props) => props.theme.errorRedTextColor};
  padding: 5px 0;
  font-weight: bold;
  letter-spacing: 1px;
  font-size: 12px;
`;

export const HorizontalLine = styled.hr<any>`
  width: 100%;
  height: 1px;
  background-color: ${(props) => (props.bgColor ? props.bgColor : "#E8ECF4")};
  margin: ${(props) => (props.margin ? props.margin : "10px 0")};
`;
